import { render, staticRenderFns } from "./CbtesAsocModal.vue?vue&type=template&id=88e496f2&"
import script from "./CbtesAsocModal.vue?vue&type=script&lang=js&"
export * from "./CbtesAsocModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports